<template>
  <div>
    <AddPM :companyId="companyId" :entityId="groupId" />
    <UpdatePM
      :details="editDetails"
      :companyId="companyId"
      :entityId="groupId"
    />
    <MasterLayout>
      <div class="dashboard_first_row pt-4 pb-3 pl-4 pr-4">
        <div class="row align-items-center white-bg py-3">
          <div class="col-md-1 remove-right-padding col-center-flex">
            <div class="square-icon-wrapper small sky-bg">
              <img src="@/assets/img/bank-building (2).svg" width="35" />
            </div>
          </div>
          <div class="col-md-7">
            <div class="d-flex flex-column flex-md-row flex-lg-row">
              <div>
                <h4 class="primary-color font-600">
                  {{ $t("text.priceManager.title") }}
                </h4>
                <p class="light-grey-text mt-3">
                  {{ $t("text.priceManager.desc") }}
                </p>
              </div>

              <div class="ml-lg-5 ml-md-5">
                <button
                  class="w-100 px-5 py-3 mb-2 rounded text-white"
                  style="background-color: #4b2d73; border: none"
                  @click="addPM"
                >
                  {{ $t("text.cDrystock.add") }}
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="mt-3">
              <label class="">
                {{ $t("text.cAggregated.type") }}
              </label>
              <select v-model="selectType">
                <option selected value="selectType">
                  {{ $t("text.cBranchReport.all") }}
                </option>
                <option v-if="typesLoading" value="">
                  {{ $t("text.priceManager.loading") }}
                </option>
                <option
                  v-else
                  :value="type.id"
                  v-for="type in companyTypes"
                  :key="type.id"
                >
                  {{ type.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="new-row"></div>

      <section class="new-row mt-3">
        <ejs-grid
          v-show="!showLoader"
          ref="dataGrid"
          :created="refreshGrid"
          :allowPaging="true"
          :allowSorting="true"
          :pageSettings="pageSettings"
          :toolbar="toolbar"
          :searchSettings="search"
          :allowExcelExport="true"
          :allowPdfExport="true"
          :toolbarClick="toolbarClick"
          :allowTextWrap="true"
          :excelQueryCellInfo="excelQueryCellInfo"
          :locale="usedLang"
        >
          <e-columns>
            <e-column width="70" field="index" headerText="#"></e-column>
            <e-column
              width="250"
              field="userFullName"
              :headerText="$t('text.form.fullName')"
            ></e-column>
            <e-column
              width="270"
              field="userEmail"
              :headerText="$t('text.form.email')"
            ></e-column>
            <e-column
              width="120"
              field="position"
              :headerText="$t('text.priceManager.level')"
            ></e-column>
            <e-column
              width="200"
              field="positionName"
              :headerText="$t('text.priceManager.position')"
            ></e-column>
            <e-column
              width="150"
              field="typeName"
              :headerText="$t('text.cAggregated.type')"
            ></e-column>
            <e-column
              width="250"
              :template="actionTemplate"
              :headerText="$t('text.products.action')"
            ></e-column>
          </e-columns>
        </ejs-grid>
        <TableLoader :showLoader="showLoader"></TableLoader>
      </section>
    </MasterLayout>
  </div>
</template>
<script>
import Vue from "vue";
import MasterLayout from "@/views/groupManagement/MasterLayout.vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import AddPM from "@/components/modals/PriceChange/AddPM";
// import ActionTemplate from "@/components/Templates/BankAcctRequest/companyTemplate.vue";
import UpdatePM from "@/components/modals/PriceChange/UpdatePM.vue";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import Paginator from "@/components/Paginator.vue";
import Jquery from "jquery";
import { defined } from "highcharts";
let $ = Jquery;

export default {
  title: "Price manager :: Epump Portal",
  components: {
    MasterLayout,
    TableLoader,
    Paginator,
    TableLoader,
    AddPM,
    UpdatePM,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      selectType: "selectType",
      companyTypes: [],
      bankNames: [],
      branches: [],
      companyId: "",
      groupId: "",
      editDetails: null,
      selectedBranch: "",
      searchTerm: "",
      formatOptions: { type: "date", format: "dd/MM/yyyy " },
      groupId: null,
      showLoader: true,
      group: null,
      typesLoading: false,
      entityType: this.$route.query.entityType,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      // actionTemplate: function () {
      //   return {
      //     template: ActionTemplate,
      //   };
      // },

      actionTemplate: function () {
        return {
          template: Vue.component("columnTemplate", {
            template:
              '<div class="btn-group btn-group-sm" role="group">' +
              '<button type="button" class="btn btn-warning" title="Update" @click="updatePM(data)" >' +
              '<i class="fa fa-edit" aria-hidden="true"></i>' +
              "</button>" +
              '<button type="button" class="btn btn-danger" title="Delete" @click="deletePM(data.id)" >' +
              '<i class="fa fa-trash-o" aria-hidden="true"></i>' +
              "</button>" +
              "</div>",
            data: function () {
              return {
                data: {},
              };
            },
            methods: {
              updatePM: function (pm) {
                this.$eventHub.$emit("openPMEditModal", pm);
              },
              deletePM: function (id) {
                this.$eventHub.$emit("deletePM", id);
              },
            },
          }),
        };
      },
    };
  },

  watch: {
    group(group) {
      if (group !== null) {
        this.getPriceManagers();
        this.getCompanyTypes();
      }
    },

    selectedBranch(branch) {
      if (branch !== null) {
        this.selectType = "selectType";
        this.getPriceManagers();
      }
    },

    selectType() {
      if (this.selectType !== null) {
        this.getPriceManagers();
      }
    },
  },
  created() {
    this.$eventHub.$on("group", (group) => {
      this.group = group;
      this.groupId = this.group.id;
      this.companyId = this.group.companyId;
    });

    if (this.$route.query.groupId) {
      this.getPriceManagers();
      this.getCompanyTypes();
    }

    if (this.$route.query.companyId) {
      this.companyId = this.$route.query.companyId;
    }

    this.$eventHub.$on("getPM", () => {
      this.getPriceManagers();
    });

    this.$eventHub.$on("openPMEditModal", (data) => {
      this.editDetails = data;
      this.$modal.show("updatePM");
    });

    this.$eventHub.$on("deletePM", (id) => {
      this.deletePM(id);
    });
  },

  beforeDestroy() {
    this.$eventHub.$off("getPM");
    this.$eventHub.$off("openPMEditModal");
    this.$eventHub.$off("deletePM");
  },

  mounted() {
    if (this.$route.query.new) {
      setTimeout(() => {
        this.$modal.show("addPM");
      }, 2000);
    }
  },

  methods: {
    addPM() {
      this.$modal.show("addPM");
    },

    deletePM(id) {
      const remove = confirm(this.$t("text.priceManager.deletePMWarn"));
      if (!remove) {
        return;
      }
      this.axios
        .delete(
          `${configObject.apiBaseUrl}/Approval/Delete/${id}`,
          configObject.authConfig()
        )
        .then((res) => {
          this.$toast.open({
            message: this.$t("text.priceManager.deletedPM"),
            type: "success",
            duration: 4000,
          });
          this.getPriceManagers();
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 4000,
          });
        });
    },

    getCompanyTypes() {
      this.typesLoading = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Approval/Type/All?companyId=${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.group.companyId
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          this.typesLoading = false;
          this.companyTypes = response.data;
        })
        .catch((error) => {});
    },

    getPriceManagers() {
      this.showLoader = true;
      let url;
      url = `${configObject.apiBaseUrl}/Approval/All?entityId=${
        this.$route.query.groupId ? this.$route.query.groupId : this.group.id
      }&entityType=Group&typeId=${
        this.selectType == "selectType" ? "" : this.selectType
      }`;

      this.axios
        .get(url, configObject.authConfig())
        .then((res) => {
          let index = 0;

          res.data.forEach((el) => {
            el.index = ++index;
            // el.date = this.$moment(el.date).format(" MMMM Do, YYYY h:mm a");
            // if (el.branch == null) {
            //   el.branch = "N/A";
            // }
          });
          // console.log(res.data);

          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: res.data,
          });
          this.refreshGrid();
          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    excelQueryCellInfo(args) {
      if (args.column.field == "dateLinked") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY");
      }
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },

    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
